import { getTheme } from "@clipboard-health/ui-theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Redirect } from "react-router-dom";

import { PageWrapper } from "../components/PageWrapper";
import { MY_SHIFTS_FULL_PATH } from "../WorkerShifts/path";
import { useIsInHomeEnabled } from "./lib/useIsInHomeEnabled";
import { InHomeRouter } from "./Router";

export function InHomeContainer() {
  const isInHomeEnabled = useIsInHomeEnabled();

  // redirect to my bookings page when home health is disabled
  if (!isInHomeEnabled) {
    return <Redirect to={MY_SHIFTS_FULL_PATH} />;
  }

  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <PageWrapper>
        <InHomeRouter />
      </PageWrapper>
    </ThemeProvider>
  );
}
